export const connected = ({ connected }) => connected

export const forceDisconnect = ({ forceDisconnect }) => forceDisconnect
